import React from "react";
import styles from "./collapsed_data_list.module.css";
import { USER_ROLES } from "../../utils/constants";

const UserData = ({ customer }) => {

  return (
    <div className={styles.data_list}>
      {customer.role !== USER_ROLES.customer &&
        <div className={styles.item_container}>
          <p className={styles.name_data}>Роль: </p>
          <div className={styles.value_data}>{customer.role}</div>
        </div>
      }
      <div className={styles.item_container}>
        <p className={styles.name_data}>Фамилия: </p>
        <div className={styles.value_data}>{customer.last_name}</div>
      </div>
      <div className={styles.item_container}>
        <p className={styles.name_data}>Имя: </p>
        <div className={styles.value_data}>{customer.first_name}</div>
      </div>
      <div className={styles.item_container}>
        <p className={styles.name_data}>Отчество: </p>
        <div className={styles.value_data}>{customer.surname}</div>
      </div>
      <div className={styles.item_container}>
        <p className={styles.name_data}>Email: </p>
        <div className={styles.value_data}>{customer.email}</div>
      </div>
      <div className={styles.item_container}>
        <p className={styles.name_data}>Телефон: </p>
        <div className={styles.value_data}>{customer.phone}</div>
      </div>
    </div>
  )
}

export default UserData;
